import { I as a, _ as l } from "./AntdIcon-DyhIFdCf.js";
import * as e from "react";
var r = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z" } }] }, name: "delete", theme: "outlined" }, n = function(t, c) {
  return /* @__PURE__ */ e.createElement(a, l({}, t, {
    ref: c,
    icon: r
  }));
}, o = /* @__PURE__ */ e.forwardRef(n);
process.env.NODE_ENV !== "production" && (o.displayName = "DeleteOutlined");
export {
  o as R
};
